/* WBC guided bundle builder (Impact port)
   Ported from design_handoff_team_trough/tt-builder.js.

   Differences from the prototype, all deliberate:
   • CONFIG + PRODUCTS + PRESETS are injected by the section as JSON
     ([data-tt2-config]) — nothing is hardcoded, the theme editor owns it.
   • All money is integer CENTS. The prototype used float dollars.
   • Cart add follows the proven wbc-nap3 pattern: prepare-bundled-sections →
     POST with sections → cart.js → dispatch cart:change → open the drawer
     with stale-open cleanup, then verify it is actually visible and route to
     /cart if not. Store cart type is `drawer` (flipped 2026-08-17).
   • Discounts are enforced server-side by the wbc-rotation-discount Function
     reading _tt_bundle off cart lines. The tier shown here must match it.
   • Size sheet shows real low-stock flags and disables sold-out sizes. */

(function () {
  if (window.__wbcTT2Loaded) return;
  window.__wbcTT2Loaded = true;

  function boot() {
    var mount = document.querySelector('[data-tt2-builder]');
    var cfgEl = document.querySelector('[data-tt2-config]');
    if (!mount || !cfgEl) return;

    var DATA;
    try { DATA = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var CONFIG = DATA.config;
    var LABELS = DATA.labels || {};
    var PRODUCTS = DATA.products;
    var PRESETS = DATA.presets;
    var CURRENT_PRODUCT_ID = DATA.currentProductId || null;
    var sectionRoot = mount.closest('.builder');
    var GUIDED = !!(sectionRoot && sectionRoot.getAttribute('data-layout') === 'guided');

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function tierFor(units) {
      var r = 0;
      CONFIG.tiers.forEach(function (t) { if (units >= t[0]) r = t[1]; });
      return r;
    }
    function money(cents) {
      var v = Math.round(cents) / 100;
      return '$' + v.toFixed(2).replace(/\.00$/, '');
    }
    function pct(r) { return Math.round(r * 100) + '%'; }
    function byId(id) {
      for (var i = 0; i < PRODUCTS.length; i++) if (PRODUCTS[i].id === id) return PRODUCTS[i];
      return null;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }

    function track(name, detail) {
      if (!CONFIG.analyticsEnabled) return;
      var payload = Object.assign({
        event: name,
        bundle_key: CONFIG.bundleKey || '',
        source_type: CONFIG.sourceType || '',
        source_handle: CONFIG.sourceHandle || ''
      }, detail || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('wbc:analytics', { detail: payload }));
    }

    function metrics(c) {
      return {
        units: c.units,
        subtotal_cents: c.sub,
        total_cents: c.total,
        savings_cents: c.save,
        discount_rate: c.rate,
        missing_size_count: c.missingSizes,
        product_ids: c.items.map(function (item) { return item.p.id; }),
        product_handles: c.items.map(function (item) { return item.p.handle || ''; })
      };
    }

    var state = {
      qty: {},
      sizeChoices: {},
      activeProductId: null,
      busy: false,
      sheet: null,
      sheetAll: false,
      justAdded: false,
      express: false,
      engaged: false,
      bundleViewed: false,
      stickyViewed: false
    };
    var currentProduct = byId(CURRENT_PRODUCT_ID);
    if (currentProduct) {
      state.qty[currentProduct.id] = 1;
      if (currentProduct.sizes && currentProduct.sizes.length) state.activeProductId = currentProduct.id;
    } else {
      PRODUCTS.forEach(function (p) {
        if (!p.preselected) return;
        state.qty[p.id] = 1;
        if (!state.activeProductId && p.sizes && p.sizes.length) state.activeProductId = p.id;
      });
    }

    function sized(p) { return !!(p.sizes && p.sizes.length); }
    function sizesFor(p) { return state.sizeChoices[p.id] || (state.sizeChoices[p.id] = []); }
    function selectedSizedProducts() {
      return PRODUCTS.filter(function (p) { return sized(p) && (state.qty[p.id] || 0) > 0; });
    }
    function activeSizedProduct() {
      var active = byId(state.activeProductId);
      if (active && sized(active) && (state.qty[active.id] || 0) > 0) return active;
      active = null;
      PRODUCTS.forEach(function (p) {
        if (!active && sized(p) && (state.qty[p.id] || 0) > 0) active = p;
      });
      state.activeProductId = active ? active.id : null;
      return active;
    }

    /* ── math (cents) ── */
    function calc() {
      var items = [], units = 0, sub = 0, hasWear = false, missing = 0;
      PRODUCTS.forEach(function (p) {
        var q = state.qty[p.id] || 0;
        if (!q) return;
        items.push({ p: p, q: q });
        units += q; sub += p.price * q;
        if (p.wearable) hasWear = true;
        if (sized(p)) {
          var ch = sizesFor(p);
          for (var i = 0; i < q; i++) if (!ch[i]) missing++;
        }
      });
      var rate = tierFor(units), save = Math.round(sub * rate), total = sub - save;
      var base = CONFIG.shipOn === 'sub' ? sub : total;
      var freeShip = CONFIG.shipOn === 'always' ? units >= 2 : base >= CONFIG.freeShip;
      return {
        items: items, units: units, sub: sub, rate: rate, save: save, total: total,
        hasWear: hasWear, missingSizes: missing, freeShip: freeShip,
        toShip: Math.max(0, CONFIG.freeShip - base),
        shipPct: CONFIG.shipOn === 'always'
          ? Math.min(1, units / 2)
          : Math.min(1, CONFIG.freeShip ? base / CONFIG.freeShip : 1),
        valid: units >= 1 && hasWear && missing === 0
      };
    }

    /* Cheapest single addition that unlocks free shipping, else the next
       tier. Never suggests sized products (each needs a size decision). */
    function nextBest(c) {
      var opts = [];
      PRODUCTS.forEach(function (p) {
        if (sized(p) || !p.nudge) return;
        if ((state.qty[p.id] || 0) > 0) return;
        var units = c.units + 1, sub = c.sub + p.price;
        var rate = tierFor(units), total = sub - Math.round(sub * rate);
        var base = CONFIG.shipOn === 'sub' ? sub : total;
        var ship = CONFIG.shipOn === 'always' ? units >= 2 : base >= CONFIG.freeShip;
        opts.push({ p: p, net: total - c.total, rate: rate, ship: ship });
      });
      if (!opts.length) return null;
      function cheapest(list) { return list.sort(function (a, b) { return a.net - b.net; })[0]; }
      var s = cheapest(opts.filter(function (o) { return !c.freeShip && o.ship; }));
      if (s) return { o: s, why: 'ship' };
      var t = cheapest(opts.filter(function (o) { return o.rate > c.rate; }));
      if (t) return { o: t, why: 'tier' };
      return null;
    }

    /* ── cart ── */
    function buildLines(c) {
      var lines = [];
      c.items.forEach(function (it) {
        if (sized(it.p)) {
          var bySize = {}, ch = sizesFor(it.p);
          for (var i = 0; i < it.q; i++) { var s = ch[i]; bySize[s] = (bySize[s] || 0) + 1; }
          Object.keys(bySize).forEach(function (s) {
            lines.push({
              id: it.p.variants[s] || it.p.variantId,
              quantity: bySize[s],
              properties: { _tt_bundle: CONFIG.bundleKey || 'team-trough', _tt_tier: pct(c.rate), _tt_size: s }
            });
          });
        } else {
          lines.push({
            id: it.p.variantId, quantity: it.q,
            properties: { _tt_bundle: CONFIG.bundleKey || 'team-trough', _tt_tier: pct(c.rate) }
          });
        }
      });
      return lines;
    }

    function syncCount(cart) {
      if (!cart || typeof cart.item_count !== 'number') return;
      document.querySelectorAll('[data-tt2-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }

    function toast(msg) {
      var t = document.querySelector('.tt2-toast');
      if (!t) { t = document.createElement('div'); t.className = 'tt2-toast'; document.body.appendChild(t); }
      t.textContent = msg;
      requestAnimationFrame(function () { t.classList.add('up'); });
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { t.classList.remove('up'); }, 2600);
    }

    function drawerIsVisible(el) {
      if (!el) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0;
    }

    /* Open the cart after an add, guaranteeing the shopper sees SOMETHING.
       Same contract as wbc-nap3: clear a stale open (show() no-ops on it),
       show, verify on screen after 700ms, else route to /cart. */
    function openCartDrawer() {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) { window.location.href = ROOT + 'cart'; return; }
      drawer.removeAttribute('open');
      drawer.style.removeProperty('opacity');
      drawer.style.removeProperty('visibility');
      if (typeof drawer.show === 'function') drawer.show();
      setTimeout(function () {
        if (!drawerIsVisible(drawer)) window.location.href = ROOT + 'cart';
      }, 700);
    }

    function afterAdd(c) {
      state.justAdded = true;
      syncStick(calc());
      if (state.express) {
        state.express = false;
        window.location.href = ROOT + 'checkout';
        return;
      }
      var drawer = document.getElementById('cart-drawer');
      var mode = CONFIG.postAdd;
      if (mode === 'auto') mode = drawer ? 'drawer' : 'sheet';
      if (mode === 'drawer' && drawer) { openCartDrawer(); return; }
      openAddedSheet(c);
    }

    function addLines(lines, label, c) {
      if (state.busy) return;
      state.busy = true;
      if (c) track('wbc_bundle_add_attempt', Object.assign(metrics(c), {
        variant_ids: lines.map(function (line) { return String(line.id); }),
        express: !!state.express
      }));
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: lines, sections: sections.join(','), sections_url: ROOT + 'variants/' + lines[0].id })
      })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'Could not add to cart.');
          return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (rr) { return rr.json(); })
            .then(function (cart) { cart.sections = json.sections; return cart; });
        });
      })
      .then(function (cart) {
        syncCount(cart);
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
        );
        if (c) track('wbc_bundle_add_success', Object.assign(metrics(c), {
          variant_ids: lines.map(function (line) { return String(line.id); }),
          cart_item_count: cart.item_count
        }));
        if (c) afterAdd(c); else toast(label + ' added');
      })
      .catch(function (err) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:error', { bubbles: true, detail: { error: (err && err.message) || 'Could not add to cart' } })
        );
        if (c) track('wbc_bundle_add_error', Object.assign(metrics(c), {
          variant_ids: lines.map(function (line) { return String(line.id); })
        }));
        toast((err && err.message) || 'Could not add to cart');
      })
      .then(function () { state.busy = false; });
    }

    /* ── bottom sheet ── */
    function ensureSheet() {
      if (state.sheet) return state.sheet;
      var el = document.createElement('div');
      el.className = 'tt2-sheet' + (GUIDED ? ' tt2-sheet--guided' : '');
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.innerHTML = '<div class="bg" data-sheet-close></div><div class="pn" data-sheet-body></div>';
      document.body.appendChild(el);
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-sheet-close]')) closeSheet();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && el.classList.contains('open')) closeSheet();
      });
      state.sheet = el;
      return el;
    }
    function openSheet(html) {
      var el = ensureSheet();
      el.querySelector('[data-sheet-body]').innerHTML = html;
      el.classList.add('open');
      document.body.style.overflow = 'hidden';
      var first = el.querySelector('button:not([data-sheet-close])');
      if (first) first.focus({ preventScroll: true });
    }
    function closeSheet() {
      if (!state.sheet) return;
      state.sheet.classList.remove('open');
      document.body.style.overflow = '';
      state.sheetAll = false;
    }

    function sizeBtn(p, s, unit) {
      var inv = (p.stock && Object.prototype.hasOwnProperty.call(p.stock, s)) ? p.stock[s] : null;
      var avail = !p.avail || p.avail[s] !== false;
      var ch = sizesFor(p);
      var low = avail && inv !== null && inv > 0 && inv <= CONFIG.lowStock;
      return '<button type="button" class="sz' + (ch[unit] === s ? ' on' : '') + '"'
        + (avail ? '' : ' disabled')
        + ' data-size="' + esc(s) + '" data-unit="' + unit + '" data-prod="' + esc(p.id) + '">'
        + esc(s) + (avail ? (low ? '<span class="szhint">' + inv + ' left</span>' : '') : '<span class="szhint">gone</span>')
        + '</button>';
    }

    function openSizeSheet(showAll) {
      var targets = showAll ? selectedSizedProducts() : [activeSizedProduct()];
      targets = targets.filter(Boolean);
      if (!targets.length) return;
      state.sheetAll = !!showAll;
      var units = '', totalUnits = 0;
      targets.forEach(function (target) {
        var q = state.qty[target.id], ch = sizesFor(target);
        totalUnits += q;
        for (var i = 0; i < q; i++) {
          var unitLabel = targets.length > 1
            ? esc(target.short) + (q > 1 ? ' ' + (i + 1) + ' of ' + q : '')
            : (q > 1 ? esc(target.short) + ' ' + (i + 1) + ' of ' + q : 'Your size');
          units += '<div class="unit"><div class="ul">'
            + unitLabel + (ch[i] ? ' · ' + esc(ch[i]) : '') + '</div><div class="szgrid">'
            + target.sizes.map(function (s) { return sizeBtn(target, s, i); }).join('')
            + '</div></div>';
        }
      });
      openSheet(''
        + '<div class="sh"><div><h3>' + (totalUnits > 1 ? 'Pick ' + totalUnits + ' sizes' : 'Pick your size') + '</h3>'
        + '<div class="sd">' + CONFIG.sizeNote + '</div></div>'
        + '<button class="sx" type="button" data-sheet-close aria-label="Close">✕</button></div>'
        + units
        + '<div class="sact"><button class="btn" type="button" data-sheet-done>Done</button></div>');
    }

    function openAddedSheet(c) {
      var n = nextBest(c);
      var up = '';
      if (n) {
        var p = n.o.p;
        up = '<div class="up">'
          + '<div class="uim">' + (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy" />' : '<span class="ico">' + esc(p.ph || '?') + '</span>') + '</div>'
          + '<div class="ut"><div class="un">' + esc(p.name) + '</div><div class="uq">'
          + (n.why === 'ship' ? 'Unlocks free shipping' : 'Takes you to ' + pct(n.o.rate) + ' off')
          + ' · net ' + money(n.o.net) + '</div></div>'
          + '<button class="ub" type="button" data-quick-add="' + esc(p.id) + '">Add</button>'
          + '</div>';
      }
      openSheet(''
        + '<div class="sh"><div><h3>In the cart.</h3>'
        + '<div class="sd">' + c.units + ' item' + (c.units > 1 ? 's' : '') + ' · ' + money(c.total)
        + (c.rate ? ' · <b>' + pct(c.rate) + ' off</b>' : '') + '</div></div>'
        + '<button class="sx" type="button" data-sheet-close aria-label="Close">✕</button></div>'
        + up
        + '<div class="sact">'
        + '<a class="btn" href="' + ROOT + 'cart">Checkout</a>'
        + '<button class="btn ghost" type="button" data-sheet-close>Keep looking</button>'
        + '</div>');
    }

    /* ── render ── */
    function shotHtml(p) {
      if (p.img) return '<div class="ps ' + (p.shot || '') + '"><img src="' + esc(p.img) + '" alt="' + esc(p.name) + '" loading="lazy" width="400" height="400" /></div>';
      return '<div class="ps empty"><div class="ph"><div class="ico">' + esc(p.ph || '?') + '</div><div class="lb">Photo<br/>coming</div></div></div>';
    }

    function presetMatches(pr) {
      var ok = true;
      PRODUCTS.forEach(function (p) {
        var want = pr.set[p.id] || 0, have = state.qty[p.id] || 0;
        if (want !== have) ok = false;
      });
      return ok;
    }
    function presetRate(pr) {
      var units = 0;
      Object.keys(pr.set).forEach(function (k) { units += pr.set[k]; });
      return tierFor(units);
    }

    function presetMath(pr) {
      var units = 0, sub = 0;
      PRODUCTS.forEach(function (p) {
        var q = pr.set[p.id] || 0;
        if (!q) return;
        units += q;
        sub += p.price * q;
      });
      var rate = tierFor(units), save = Math.round(sub * rate);
      return { units: units, sub: sub, rate: rate, save: save, total: sub - save };
    }

    function guidedProductHtml(pr) {
      var parts = [];
      PRODUCTS.forEach(function (p) {
        var q = pr.set[p.id] || 0;
        if (!q) return;
        var image = p.img
          ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="360" height="360" />'
          : '<span class="gp-placeholder">' + esc(p.ph || '?') + '</span>';
        parts.push('<span class="gp-item" data-product-id="' + esc(p.id) + '">'
          + '<span class="gp-image">' + image + '</span>'
          + '<span class="gp-name">' + esc(p.name) + (q > 1 ? ' ×' + q : '') + '</span>'
          + '</span>');
      });
      return parts.join('<span class="gp-plus" aria-hidden="true">+</span>');
    }

    function guidedPresetHtml() {
      if (!PRESETS.length) return '';
      var active = null;
      PRESETS.forEach(function (pr) { if (!active && presetMatches(pr)) active = pr; });
      var primary = active;
      if (!primary && CURRENT_PRODUCT_ID) {
        PRESETS.forEach(function (pr) {
          if (!primary && (pr.set[CURRENT_PRODUCT_ID] || 0) > 0) primary = pr;
        });
      }
      primary = primary || PRESETS[0];
      var selected = presetMatches(primary);
      var main = presetMath(primary);
      var alternatives = PRESETS.filter(function (pr) { return pr.id !== primary.id; });
      var reassurance = CONFIG.shipOn === 'always' && main.units >= 2
        ? 'Free U.S. standard shipping · 30-day returns'
        : '30-day returns · Secure checkout';
      var other = alternatives.map(function (pr) {
        var math = presetMath(pr);
        return '<button class="preset-option" type="button" data-preset="' + esc(pr.id) + '" aria-pressed="false">'
          + '<span class="preset-option__copy"><strong>' + esc(pr.title) + '</strong><small>' + esc(pr.desc) + '</small></span>'
          + '<span class="preset-option__price"><strong>' + money(math.total) + '</strong>'
          + (math.save ? '<small>' + esc(LABELS.youSave || 'You save') + ' ' + money(math.save) + '</small>' : '')
          + '</span></button>';
      }).join('');
      return '<section class="guided-preset" aria-label="' + esc(LABELS.recommended || 'Recommended set') + '">'
        + '<header class="guided-preset__head"><h3>' + esc(primary.title) + '</h3><p>' + esc(primary.desc) + '</p></header>'
        + '<div class="guided-preset__main">'
        + '<div class="guided-preset__products" aria-label="Items in this set">' + guidedProductHtml(primary) + '</div>'
        + '<div class="guided-preset__decision"><div class="guided-preset__price">'
        + '<span><strong>' + money(main.total) + '</strong><small>' + esc(LABELS.total || 'Total') + '</small></span>'
        + (main.save ? '<em>' + esc(LABELS.youSave || 'You save') + ' ' + money(main.save) + '</em>' : '')
        + '</div><button class="btn preset-cta" type="button" data-preset="' + esc(primary.id) + '" aria-pressed="' + selected + '">'
        + esc(selected ? (LABELS.selected || 'Selected') : (LABELS.chooseSet || 'Choose this set'))
        + '</button><p>' + reassurance + '</p></div></div>'
        + (other ? '<details class="preset-more"><summary>' + esc(LABELS.otherOptions || 'Other set options')
          + '<span aria-hidden="true">+</span></summary><div class="preset-options">' + other + '</div></details>' : '')
        + '</section>';
    }

    function render() {
      var c = calc();

      /* Presets carry the dollar story: the price you pay and what you save.
         Mark, 8/17: "show the new price and the savings, not make me do math." */
      mount.querySelector('[data-presets]').innerHTML = GUIDED ? guidedPresetHtml() : PRESETS.map(function (pr) {
        var sub = 0;
        Object.keys(pr.set).forEach(function (k) {
          var p = byId(k);
          if (p) sub += p.price * pr.set[k];
        });
        var rate = presetRate(pr), save = Math.round(sub * rate), total = sub - save;
        var selected = presetMatches(pr);
        return '<button class="preset' + (selected ? ' on' : '') + '" type="button" data-preset="' + esc(pr.id) + '" aria-pressed="' + selected + '">'
          + '<span class="pl"><span class="pk"><span class="pm" aria-hidden="true">' + (selected ? '✓' : '+') + '</span><span class="pt">' + esc(pr.title) + '</span></span><span class="pd">' + esc(pr.desc) + '</span></span>'
          + '<span class="pv"><span class="pp">' + money(total) + '</span>'
          + (save ? '<span class="sv">save ' + money(save) + '</span>' : '') + '</span>'
          + '<span class="pc"><span>' + (selected ? 'Bundle selected' : 'Choose this bundle') + '</span><span aria-hidden="true">' + (selected ? '✓' : '→') + '</span></span>'
          + '</button>';
      }).join('');

      mount.querySelector('[data-ladder]').innerHTML = GUIDED ? '' : CONFIG.tiers.map(function (t, i) {
        var last = i === CONFIG.tiers.length - 1;
        var live = c.units === t[0] || (last && c.units >= t[0]);
        var done = c.units > t[0] && !last;
        return '<div class="rung' + (live ? ' live' : done ? ' done' : '') + '">'
          + '<div class="n">' + pct(t[1]) + '</div>'
          + '<div class="k">' + t[0] + (last ? '+' : '') + ' items</div>'
          + '</div>';
      }).join('');

      mount.querySelector('[data-picks]').innerHTML = PRODUCTS.map(function (p) {
        var q = state.qty[p.id] || 0;
        var edit = '';
        if (q && sized(p) && CONFIG.contextualSummary) {
          var chosen = sizesFor(p).slice(0, q).filter(Boolean);
          var editLabel = q === 1
            ? (chosen[0] ? 'Size ' + chosen[0] + ' · Edit' : 'Choose size')
            : 'Edit ' + q + ' sizes';
          edit = '<button class="pick-edit" type="button" data-edit-size="' + esc(p.id) + '">' + esc(editLabel) + '</button>';
        }
        var foot = q
          ? '<span class="qty">'
            + '<button type="button" data-step="-1" data-id="' + esc(p.id) + '" aria-label="One fewer ' + esc(p.name) + '">−</button>'
            + '<span class="qv">' + q + '</span>'
            + '<button type="button" data-step="1" data-id="' + esc(p.id) + '"' + (q >= CONFIG.maxQty ? ' disabled' : '') + ' aria-label="One more ' + esc(p.name) + '">+</button>'
            + '</span>'
          : (p.wearable ? '<span class="req">Counts as your wearable</span>' : '');
        return '<div class="pick' + (q ? ' on' : '') + '" data-product-id="' + esc(p.id) + '">'
          + '<button class="picktog" type="button" data-pick="' + esc(p.id) + '" aria-pressed="' + (q > 0)
          + '" aria-label="' + (q && sized(p) && CONFIG.contextualSummary ? 'Edit size for ' : q ? 'Remove ' : 'Add ') + esc(p.name) + '"></button>'
          + shotHtml(p)
          + '<span class="chk">✓</span>'
          + '<span class="pb">'
          + '<span class="pn">' + esc(p.name) + '</span>'
          + '<span class="pp">' + money(p.price) + '</span>'
          + foot
          + edit
          + '</span>'
          + '</div>';
      }).join('');

      /* One unit → size pills inline, zero extra taps. Multiple units →
         summary + sheet, one picker per unit. */
      var sizedSel = activeSizedProduct();
      var sz = mount.querySelector('[data-sizes]');
      sz.classList.toggle('show', !!sizedSel);
      if (sizedSel) {
        var q2 = state.qty[sizedSel.id], ch = sizesFor(sizedSel);
        sz.querySelector('.lb').textContent = sizedSel.short + ' size';
        if (q2 === 1) {
          mount.querySelector('[data-szslot]').innerHTML =
            '<div class="szgrid">' + sizedSel.sizes.map(function (s) { return sizeBtn(sizedSel, s, 0); }).join('') + '</div>';
        } else {
          var parts = [];
          for (var i = 0; i < q2; i++) parts.push(ch[i] ? esc(ch[i]) : '<i>pick</i>');
          mount.querySelector('[data-szslot]').innerHTML =
            '<button class="szsum" type="button" data-open-sizes>'
            + '<span class="ss">' + esc(sizedSel.short) + ' ×' + q2 + ' — ' + parts.join(' · ') + '</span>'
            + '<span class="sa">Choose →</span></button>';
        }
      }

      var t = '';
      if (c.units) {
        if (GUIDED) {
          t += '<div class="tline tot"><span class="k">' + esc(LABELS.total || 'Total') + '</span><span class="v">' + money(c.total) + '</span></div>';
          if (c.rate) t += '<div class="tline save"><span class="k">' + esc(LABELS.youSave || 'You save') + ' ' + pct(c.rate) + '</span><span class="v">' + money(c.save) + '</span></div>';
        } else {
          t += '<div class="tline"><span class="k">' + c.units + ' item' + (c.units > 1 ? 's' : '') + '</span><span class="v">' + money(c.sub) + '</span></div>';
          if (c.rate) t += '<div class="tline save"><span class="k">Bundle discount · ' + pct(c.rate) + '</span><span class="v">− ' + money(c.save) + '</span></div>';
          t += '<div class="tline tot"><span class="k">You pay</span><span class="v">' + money(c.total)
            + (c.rate ? ' <span class="strike" style="font-size:16px">' + money(c.sub) + '</span>' : '') + '</span></div>';
        }
        t += c.freeShip
          ? '<div class="nudge ok">✓ Free shipping unlocked.</div>'
          : (CONFIG.shipOn === 'always'
            ? '<div class="nudge">Add any second item — your bundle ships free.</div>'
            : '<div class="nudge">' + money(c.toShip) + ' from free shipping.</div>');
        var n = nextBest(c);
        if (n) {
          t += '<button class="nudgebtn" type="button" data-quick-add="' + esc(n.o.p.id) + '">'
            + '<span class="nl">Add the <b>' + esc(n.o.p.name) + '</b> for <b>' + money(n.o.net) + '</b> more<br/>'
            + (n.why === 'ship' ? '→ unlocks free shipping' : '→ takes you to ' + pct(n.o.rate) + ' off')
            + '</span><span class="nr">+</span></button>';
        }
      } else {
        t += '<div class="nudge" style="color:rgba(0,0,0,.45)">' + CONFIG.emptyNote + '</div>';
      }
      mount.querySelector('[data-tally]').innerHTML = t;

      var btn = mount.querySelector('[data-add]');
      btn.disabled = !c.valid;
      btn.textContent = c.units
        ? (GUIDED ? (c.missingSizes ? 'Choose ' + (c.missingSizes > 1 ? c.missingSizes + ' sizes' : 'a size') : (c.units > 1 ? 'Add set — ' : 'Add to cart — ') + money(c.total)) : 'Add ' + c.units + ' item' + (c.units > 1 ? 's' : '') + ' — ' + money(c.total))
        : 'Add to cart';
      /* One clear CTA while invalid — two gray slabs read as a dead page. */
      var ex = mount.querySelector('[data-express]');
      if (ex) { ex.disabled = !c.valid; ex.style.display = c.valid ? '' : 'none'; }
      mount.querySelector('[data-pays]').textContent =
        c.valid && c.total >= 5000 ? 'or 4 interest-free payments of ' + money(c.total / 4) : '';
      mount.querySelector('[data-note]').textContent = !c.units ? (CONFIG.startNote || 'Pick a tee or a cap to start')
        : c.missingSizes ? 'Pick ' + (c.missingSizes > 1 ? c.missingSizes + ' sizes' : 'your size') + ' to continue'
        : !c.hasWear ? 'Add a tee or a cap to unlock the bundle'
        : 'Free shipping · 30-day returns';

      syncStick(c);
    }

    function selectionSummary(c) {
      if (!CONFIG.contextualSummary || !c.items.length) return '';
      if (c.items.length === 1 && c.items[0].q === 1) {
        var only = c.items[0].p;
        var size = sized(only) ? sizesFor(only)[0] : '';
        return only.short + (size ? ' · ' + size : (sized(only) ? ' · choose size' : ''));
      }
      var first = c.items[0];
      var firstSize = sized(first.p) ? sizesFor(first.p)[0] : '';
      var extra = c.units - 1;
      return first.p.short + (firstSize ? ' · ' + firstSize : '') + (extra > 0 ? ' + ' + extra + ' more' : '');
    }

    function syncStick(c) {
      var bar = document.querySelector('[data-tt2-stick]');
      if (!bar) return;
      var prog = bar.querySelector('.sprog');
      if (!prog) {
        prog = document.createElement('div');
        prog.className = 'sprog';
        prog.innerHTML = '<i></i>';
        bar.insertBefore(prog, bar.firstChild);
      }
      var showBar = c.units > 0 && (!CONFIG.stickyRequiresInteraction || state.engaged);
      bar.classList.toggle('up', showBar);
      if (showBar && !state.stickyViewed) {
        state.stickyViewed = true;
        track('wbc_bundle_sticky_view', metrics(c));
      }
      prog.classList.toggle('done', c.freeShip);
      prog.querySelector('i').style.width = Math.round(c.shipPct * 100) + '%';
      if (!c.units) return;
      if (GUIDED) {
        bar.querySelector('[data-s-c]').textContent = selectionSummary(c) || (c.units + ' item' + (c.units > 1 ? 's' : '')
          + (c.missingSizes ? ' · ' + c.missingSizes + ' size' + (c.missingSizes > 1 ? 's' : '') + ' needed' : ' · Ready to add'));
        bar.querySelector('[data-s-t]').innerHTML = money(c.total) + '<span class="st-label">' + esc(LABELS.total || 'Total') + '</span>';
      } else {
        bar.querySelector('[data-s-c]').textContent =
          c.units + ' item' + (c.units > 1 ? 's' : '')
          + (c.rate ? ' · ' + pct(c.rate) + ' off' : '')
          + ' · ' + (c.freeShip ? 'ships free'
            : (CONFIG.shipOn === 'always' ? 'add one more, ships free' : money(c.toShip) + ' to free ship'));
        bar.querySelector('[data-s-t]').innerHTML =
          money(c.total) + (c.rate ? '<span class="sv">saved ' + money(c.save) + '</span>' : '');
      }
      var b = bar.querySelector('[data-s-btn]');
      b.disabled = false;
      if (state.justAdded) { b.textContent = 'Checkout'; return; }
      b.textContent = c.missingSizes ? (GUIDED ? 'Choose size' : 'Pick size') : (GUIDED && c.units > 1 ? 'Add set' : 'Add');
    }

    /* ── wiring ── */
    function setQty(id, q) {
      q = Math.max(0, Math.min(CONFIG.maxQty, q));
      state.qty[id] = q;
      state.justAdded = false;
      var p = byId(id);
      if (p && sized(p)) {
        state.sizeChoices[id] = sizesFor(p).slice(0, q);
        if (q > 0) state.activeProductId = id;
        else if (state.activeProductId === id) state.activeProductId = null;
      }
      if (!q) delete state.qty[id];
    }

    mount.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-preset]'))) {
        var pr = PRESETS.filter(function (x) { return x.id === el.getAttribute('data-preset'); })[0];
        if (!pr) return;
        state.engaged = true;
        state.qty = {}; state.sizeChoices = {}; state.activeProductId = null; state.justAdded = false;
        Object.keys(pr.set).forEach(function (k) {
          state.qty[k] = pr.set[k];
          var p = byId(k);
          if (!state.activeProductId && p && sized(p)) state.activeProductId = k;
        });
        prefillSize();
        track('wbc_bundle_preset_select', { preset_id: pr.id, preset_title: pr.title });
        render();
        /* The sheet earns its interruption only for multi-unit picks; a
           single missing size has inline pills right on the page. */
        var missingUnits = 0;
        PRODUCTS.forEach(function (p) { if (sized(p) && state.qty[p.id]) missingUnits += Math.max(0, state.qty[p.id] - sizesFor(p).filter(Boolean).length); });
        if (missingUnits > 1) openSizeSheet(true);
        else if (missingUnits === 1 && window.matchMedia('(max-width: 759px)').matches) {
          window.setTimeout(function () {
            var sizes = mount.querySelector('[data-sizes]');
            if (sizes) sizes.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'center'
            });
          }, 40);
        }
        return;
      }
      if ((el = e.target.closest('[data-step]'))) {
        var id = el.getAttribute('data-id');
        state.engaged = true;
        setQty(id, (state.qty[id] || 0) + parseInt(el.getAttribute('data-step'), 10));
        var steppedProduct = byId(id);
        track('wbc_bundle_product_change', { product_id: id, product_handle: steppedProduct && steppedProduct.handle, quantity: state.qty[id] || 0, action: 'quantity' });
        render();
        return;
      }
      if ((el = e.target.closest('[data-edit-size]'))) {
        var editId = el.getAttribute('data-edit-size');
        var editProduct = byId(editId);
        if (!editProduct) return;
        state.engaged = true;
        state.activeProductId = editId;
        track('wbc_bundle_size_edit', { product_id: editId, product_handle: editProduct.handle || '', quantity: state.qty[editId] || 0 });
        render();
        if ((state.qty[editId] || 0) > 1) openSizeSheet();
        else window.setTimeout(function () {
          var sizePanel = mount.querySelector('[data-sizes]');
          if (sizePanel) sizePanel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        }, 30);
        return;
      }
      if ((el = e.target.closest('[data-pick]'))) {
        var pid = el.getAttribute('data-pick');
        var was = (state.qty[pid] || 0) > 0;
        var pickedProduct = byId(pid);
        state.engaged = true;
        if (was && CONFIG.contextualSummary && pickedProduct && sized(pickedProduct)) {
          state.activeProductId = pid;
          track('wbc_bundle_size_edit', { product_id: pid, product_handle: pickedProduct.handle || '', quantity: state.qty[pid] || 0 });
          render();
          if ((state.qty[pid] || 0) > 1) openSizeSheet();
          else window.setTimeout(function () {
            var sizePanel = mount.querySelector('[data-sizes]');
            if (sizePanel) sizePanel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          }, 30);
          return;
        }
        setQty(pid, was ? 0 : 1);
        if (!was) prefillSize();
        track('wbc_bundle_product_change', { product_id: pid, product_handle: pickedProduct && pickedProduct.handle, quantity: state.qty[pid] || 0, action: was ? 'remove' : 'add' });
        render();
        return;
      }
      if ((el = e.target.closest('.sizes [data-size]'))) {
        var sp = byId(el.getAttribute('data-prod'));
        if (!sp) return;
        state.engaged = true;
        sizesFor(sp)[parseInt(el.getAttribute('data-unit'), 10)] = el.getAttribute('data-size');
        try { localStorage.setItem('tt:size', el.getAttribute('data-size')); } catch (err) {}
        track('wbc_bundle_size_select', { product_id: sp.id, product_handle: sp.handle || '', variant_id: String(sp.variants[el.getAttribute('data-size')] || sp.variantId), size: el.getAttribute('data-size'), unit_index: parseInt(el.getAttribute('data-unit'), 10) });
        render();
        return;
      }
      if (e.target.closest('[data-open-sizes]')) { state.engaged = true; openSizeSheet(); return; }
      if ((el = e.target.closest('[data-quick-add]'))) {
        state.engaged = true;
        setQty(el.getAttribute('data-quick-add'), 1);
        var quickProduct = byId(el.getAttribute('data-quick-add'));
        track('wbc_bundle_product_change', { product_id: quickProduct && quickProduct.id, product_handle: quickProduct && quickProduct.handle, quantity: 1, action: 'nudge_add' });
        render();
        return;
      }
      if (e.target.closest('[data-express]')) {
        state.engaged = true;
        var ce = calc();
        if (!ce.valid) { if (ce.missingSizes) openSizeSheet(selectedSizedProducts().length > 1); return; }
        state.express = true;
        addLines(buildLines(ce), ce.units + ' item' + (ce.units > 1 ? 's' : ''), ce);
        return;
      }
      if (e.target.closest('[data-add]')) {
        state.engaged = true;
        var c = calc();
        if (!c.valid) { if (c.missingSizes) openSizeSheet(selectedSizedProducts().length > 1); return; }
        addLines(buildLines(c), c.units + ' item' + (c.units > 1 ? 's' : ''), c);
      }
    });

    ensureSheet().addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-size]'))) {
        var val = el.getAttribute('data-size');
        var prod = byId(el.getAttribute('data-prod'));
        if (!prod) return;
        state.engaged = true;
        state.activeProductId = prod.id;
        sizesFor(prod)[parseInt(el.getAttribute('data-unit'), 10)] = val;
        try { localStorage.setItem('tt:size', val); } catch (err) {}
        track('wbc_bundle_size_select', { product_id: prod.id, product_handle: prod.handle || '', variant_id: String(prod.variants[val] || prod.variantId), size: val, unit_index: parseInt(el.getAttribute('data-unit'), 10) });
        render();
        var c = calc();
        if (!c.missingSizes) { closeSheet(); } else { openSizeSheet(state.sheetAll); }
        return;
      }
      if (e.target.closest('[data-sheet-done]')) { closeSheet(); return; }
      if ((el = e.target.closest('[data-quick-add]'))) {
        var p = byId(el.getAttribute('data-quick-add'));
        if (!p) return;
        closeSheet();
        addLines([{ id: p.variantId, quantity: 1, properties: { _tt_bundle: CONFIG.bundleKey || 'team-trough', _tt_tier: 'upsell' } }], p.name);
        return;
      }
    });

    var stick = document.querySelector('[data-tt2-stick]');
    if (stick) stick.addEventListener('click', function (e) {
      state.engaged = true;
      if (e.target.closest('[data-s-review]')) {
        var review = mount.querySelector('.summary');
        if (review) review.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (!e.target.closest('[data-s-btn]')) return;
      if (state.justAdded) { window.location.href = ROOT + 'cart'; return; }
      var c = calc();
      if (c.missingSizes) { openSizeSheet(selectedSizedProducts().length > 1); return; }
      if (c.valid) addLines(buildLines(c), c.units + ' item' + (c.units > 1 ? 's' : ''), c);
      else {
        var r = mount.getBoundingClientRect();
        var top = r.top + window.scrollY - 20;
        try { window.scrollTo({ top: top, behavior: 'smooth' }); } catch (err) {}
        setTimeout(function () { if (Math.abs(window.scrollY - top) > 4) window.scrollTo(0, top); }, 350);
      }
    });

    document.addEventListener('cart:change', function (e) {
      if (e.detail && e.detail.cart) syncCount(e.detail.cart);
      /* If quantities change in the drawer, the sticky "Checkout" state is
         stale — revert it to Add on the next interaction cycle. */
      if (e.detail && e.detail.baseEvent === 'line-item:change') {
        state.justAdded = false;
        syncStick(calc());
      }
    });

    /* Size memory — prefill the first unit so a returning customer's default
       bundle is valid with zero taps. Key 'tt:size', never cleared. */
    function prefillSize() {
      try {
        var last = localStorage.getItem('tt:size');
        if (!last) return;
        PRODUCTS.forEach(function (p) {
          if (!sized(p) || !(state.qty[p.id] > 0)) return;
          var ch = sizesFor(p);
          var ok = p.sizes.indexOf(last) >= 0 && (!p.avail || p.avail[last] !== false);
          if (!ch[0] && ok) ch[0] = last;
        });
      } catch (err) {}
    }

    prefillSize();
    if ('IntersectionObserver' in window && sectionRoot) {
      var bundleObserver = new IntersectionObserver(function (entries) {
        if (state.bundleViewed || !entries.some(function (entry) { return entry.isIntersecting; })) return;
        state.bundleViewed = true;
        track('wbc_bundle_view', metrics(calc()));
        bundleObserver.disconnect();
      }, { threshold: 0.15 });
      bundleObserver.observe(sectionRoot);
    } else {
      state.bundleViewed = true;
      track('wbc_bundle_view', metrics(calc()));
    }
    render();
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(syncCount).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
